import Component from './component'
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
    return {
        paginas: state.database.paginas.map(obj => obj? obj.toObject() : undefined),
        auth : state.ui.login.get('usuario')
    }
}

export default connect(mapStateToProps)(Component)


// WEBPACK FOOTER //
// ./src/views/administrativo/container.js